// Public client-side credentials for the Google Drive + Gmail
// integrations, in GCP project `agentic-ai-operating-model`.
//
// GOOGLE_API_KEY is used in exactly ONE place: the Picker's
// `setDeveloperKey` in `drive.ts`. Every Drive REST call there
// authenticates with the operator's OAuth token and sends no
// key, and `gmail.ts` never touches it - so a change to Gmail or
// to our Drive calls has no bearing on this key. It cannot be
// dropped in favour of the user's credentials: the Picker
// requires a developer key per Google's docs.
//
// SAFE IN BUNDLE, but NOT because of a referrer restriction -
// the key deliberately has no application restriction, and
// re-adding one is a rejected alternative, not a TODO. The
// Picker validates the developer key from inside its
// docs.google.com iframe, so Google's own instructions are to
// allowlist `https://docs.google.com/*` alongside your origins;
// without it the Picker dies with "The API developer key is
// invalid" (confirmed the hard way on prod). But any third party
// who lifts the key can stand up their own Picker and present
// that exact referrer, so the one entry Google requires is the
// one that neuters the control. Referrer restrictions also only
// bind honest browsers - a scripted client sets the header
// itself.
//
// What does bound the key: it is API-restricted to the Drive +
// Picker APIs (Google's recommended pair for a Picker key), both
// of which are free - so there is no billing exposure - and it
// grants nothing on private Drive data, which needs the user's
// OAuth token that the key cannot mint. Worst case for a leaked
// copy is quota burn and reading files already shared
// public-by-link.
//
// GOOGLE_CLIENT_ID is the credential that DOES need per-env
// console work: its Authorized JavaScript origins take no
// wildcards. See CLAUDE.md "Google sign-in on QA envs".
//
// `gmail.readonly` is the narrowest read scope that lets us list /
// read threads. `gmail.compose` is requested only by the email card's
// "Create draft in Gmail", in the operator's browser at the click: no
// stored grant and no agent can write to anyone's Gmail
// (docs/Y2026-Q4/design-gmail-reply-drafts.md). It can also send, so
// nothing else may ask for it. `calendar.events` is requested the same way, only by an
// action's "Add to cal", to put a reminder on the operator's own calendar
// (docs/Y2026-Q4/design-add-to-calendar.md).
export const GOOGLE_CLIENT_ID =
  "817990859752-51qepiah2o59o94br0chrrbcej4s1ah1.apps.googleusercontent.com";
// Console entry: "agents-web-picker-key" in project
// `agentic-ai-operating-model` - the literal below is otherwise
// unidentifiable among the project's keys.
export const GOOGLE_API_KEY = "AIzaSyAEek1lMvWb0WL5q0cLUfxuAoQxley4Cio";
export const GOOGLE_GMAIL_SCOPE = "https://www.googleapis.com/auth/gmail.readonly";
export const GOOGLE_GMAIL_COMPOSE_SCOPE = "https://www.googleapis.com/auth/gmail.compose";
export const GOOGLE_CALENDAR_EVENTS_SCOPE = "https://www.googleapis.com/auth/calendar.events";
// `drive.readonly` rather than the narrower `drive.file` because
// `drive.files.list?q='FOLDER_ID' in parents` needs read access
// to the folder's children, which `drive.file` does NOT grant for
// items the user hasn't explicitly opened via the picker. The
// picker UI still constrains what the operator actually shares -
// we only fetch the folder they pick - so the broader scope is
// only used to walk INSIDE that scope, never to enumerate
// arbitrary Drive content.
export const GOOGLE_DRIVE_SCOPE = "https://www.googleapis.com/auth/drive.readonly";

// Sanity guard - replace these placeholder strings with real
// values from the Google Cloud Console if/when we rotate. The
// `.startsWith("PLACEHOLDER")` check matches the legacy
// `GOOGLE_PICKER_READY` pattern; the panel disables itself when
// false rather than blowing up at GSI init time.
export const GOOGLE_OAUTH_READY =
  !GOOGLE_CLIENT_ID.startsWith("PLACEHOLDER") &&
  !GOOGLE_API_KEY.startsWith("PLACEHOLDER");
